import { CommApiInstance } from "Utils/CommApiInstance";

const GameScndPasswdChngApi = async (
    gameSvcCd:string,
    
) => {
    return await CommApiInstance.post(`memb/${gameSvcCd}/scnd_passwd/init`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default GameScndPasswdChngApi;